'use strict';

/* eslint-disable */
var orderView = {};

orderView.init = function init() {
    function addOption(qty) {
        qty -= 1;

        if (qty == 0) {
            $('select.qty-select').filter(':first').removeClass('qty-select');
            return;
        }
        $('select.qty-select').filter(':first').append(new Option(qty, qty));
        addOption(qty);
    }

    $(document).ready(function () {
        $('select.qty-select').each(function () {
            addOption($(this).val());
        });
    });

    $('[data-select-all]').click(function () {
        $('[data-return-items] .register-return-item-name input:checkbox').not(this).prop('checked', this.checked);

        if ($(this).prop('checked')) {
            $('[data-return-items] .register-return-select-fields select').removeAttr('disabled');
            $('[data-return-items] .register-return-select-wrapper').addClass('opacity-full');
        } else {
            $('[data-return-items] .register-return-select-fields select').attr('disabled', 'disabled');
            $('[data-return-items] .register-return-select-wrapper').removeClass('opacity-full');
        }
    });

    $('[data-select-all-mobile]').click(function () {
        $('[data-return-items-mobile] .register-return-item-name input:checkbox').not(this).prop('checked', this.checked);

        if ($(this).prop('checked')) {
            $('[data-return-items-mobile] .register-return-select-fields select').removeAttr('disabled');
            $('[data-return-items-mobile] .register-return-select-wrapper').addClass('opacity-full');
        } else {
            $('[data-return-items-mobile] .register-return-select-fields select').attr('disabled', 'disabled');
            $('[data-return-items-mobile] .register-return-select-wrapper').removeClass('opacity-full');
        }
    });

    if ($('input[type="checkbox"]').hasClass('register-return-checkbox')) {
        $('input[type="checkbox"]').on('click', function () {
            if ($(this).prop('checked')) {
                $(this).closest('.register-return-item').find('.register-return-select-fields select').removeAttr('disabled');
                $(this).closest('.register-return-item').find('.register-return-select-wrapper').addClass('opacity-full');
            } else {
                $(this).closest('.register-return-item').find('.register-return-select-fields select').attr('disabled', 'disabled');
                $(this).closest('.register-return-item').find('.register-return-select-wrapper').removeClass('opacity-full');
            }
        });
    }

    $(document).on('change', '.typeOfReturn', function () {
        if ($(this).val() == 1) {
            $(this).closest('.register-return-select-fields').find('.reasonOfReturn option[value="7"]').attr('selected', true).removeAttr('disabled');
            $(this).closest('.register-return-select-fields').find('.reasonOfReturn option[value="7"]').siblings().attr('disabled', 'disabled');
        } else if ($(this).val() > 1) {
            $(this).closest('.register-return-select-fields').find('.reasonOfReturn option[value="7"]').siblings().removeAttr('disabled');
            $(this).closest('.register-return-select-fields').find('.reasonOfReturn option[value="7"]').attr('selected', false).attr('disabled', 'disabled');
        }
    });

    $(document).on('click', '.unifaunLink', function () {
        var unifaunUrl = $('.unifaunUrl').data('unifaun');
        window.location.href = unifaunUrl;
    });

    $('.register-return-submit-button').on('click', function () {
        var text = $('.register-return-description-text').val();
        var newText = text.replace(/[\r\n]+/gm, ' ');
        $('.register-return-description-text').val(newText);
    });
};

module.exports = orderView;
